// extracted by mini-css-extract-plugin
export default {"page":"hX-z","cartModal":"iX-z","checkout":"jX-z","placeholder":"kX-z","account":"lX-z"};